import {
  ausTypeFieldName,
  doAusStatusFieldName,
  duAusStatusFieldName,
  duUrlaAusStatusFieldName,
  lpaAusStatusFieldName,
  lpAusStatusFieldName,
  lpUrlaAusStatusFieldName,
  lqaAusStatusFieldName,
  waiverAusStatusFieldName,
} from 'constants/loanApplication';

export const blurRequiredFields = ['program', 'rate', 'dti'];

const wUnderWritingStatusFieldName = 'w';
const sUnderWritingStatusFieldName = 's';

export const ausRelatedFields = [
  duAusStatusFieldName,
  lpAusStatusFieldName,
  ausTypeFieldName,
  waiverAusStatusFieldName,
  lqaAusStatusFieldName,
  duUrlaAusStatusFieldName,
  lpUrlaAusStatusFieldName,
  doAusStatusFieldName,
  lpaAusStatusFieldName,
];

export const ausBooleanFields = [
  duAusStatusFieldName,
  lpAusStatusFieldName,
  waiverAusStatusFieldName,
  lqaAusStatusFieldName,
  duUrlaAusStatusFieldName,
  lpUrlaAusStatusFieldName,
  doAusStatusFieldName,
  lpaAusStatusFieldName,
];

export const reportsAllowedFields = [
  'i',
  sUnderWritingStatusFieldName,
  wUnderWritingStatusFieldName,
];

export const fico = 'fico';
